/**
 * Universal Portrait-Image “contain” Toggler
 *
 * Handles both static and dynamically injected grid/gallery images by:
 *   1. Scanning on DOMContentLoaded
 *   2. Re-scanning on scroll & resize (for AJAX/infinite-scroll inserts)
 *   3. Waiting for each image’s load event if not yet complete
 *
 * Targets:
 *   • img.main-slide-img
 *   • img.imageslide-item_image
 *   • img.swiper-slide-image
 *   • #product-grid .main-preview-img
 *
 * For each image, toggles the `contain` class based on its natural dimensions:
 *   - Portrait (naturalHeight > naturalWidth) → add `.contain`
 *   - Otherwise → remove `.contain`
 *
 * CSS requirement:
 *   .main-preview-img.contain,
 *   .main-slide-img.contain,
 *   .imageslide-item_image.contain,
 *   .swiper-slide-image.contain {
 *     object-fit: contain !important;
 *   }
 */
(function() {
  const SELECTORS = [
    "img.main-slide-img",
    "img.imageslide-item_image",
    "img.swiper-slide-image",
    "#product-grid .main-preview-img"
  ].join(", ");

  function applyContain(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    const isPortrait = img.naturalHeight > img.naturalWidth;
    img.classList.toggle("contain", isPortrait);
  }

  function scanAndApply() {
    document.querySelectorAll(SELECTORS).forEach(img => {
      if (img.dataset.containChecked === "true") return;
      if (!img.complete) {
        img.addEventListener("load", () => {
          applyContain(img);
          img.dataset.containChecked = "true";
        }, { once: true });
      } else {
        applyContain(img);
        img.dataset.containChecked = "true";
      }
    });
  }

  function throttle(fn, wait = 200) {
    let last = 0;
    return function(...args) {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn.apply(this, args);
      }
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    scanAndApply();
    const throttledScan = throttle(scanAndApply, 250);
    window.addEventListener("scroll", throttledScan, { passive: true });
    window.addEventListener("resize", throttledScan);
  });
})();
